import React, { FC } from 'react';
import { Check } from 'lucide-react';
import { ApproveAllButton, ApproveAllCount } from '../NewVerificationTab.styles';
import { ExpandableTableRow } from '../NewVerificationTab.data';
import { countUnreviewedManualValues } from '../NewVerificationTab.utils';

interface ApproveAllManualValuesButtonProps {
  id: string;
  /** The rows of the one table this button acts on. */
  rows: ExpandableTableRow[];
  /** Approving writes the Final Review column, so only a user who may edit it gets the button. */
  canEditFinalReview: boolean;
  onApproveAll: () => void;
}

export const ApproveAllManualValuesButton: FC<ApproveAllManualValuesButtonProps> = ({
  id,
  rows,
  canEditFinalReview,
  onApproveAll,
}) => {
  if (!canEditFinalReview) {
    return null;
  }

  const count = countUnreviewedManualValues(rows);

  return (
    <ApproveAllButton type='button' data-testid={id} disabled={count === 0} onClick={onApproveAll}>
      <Check className='w-4 h-4' strokeWidth={3} />
      Approve All
      {count > 0 && <ApproveAllCount data-testid={`${id}-count`}>{count}</ApproveAllCount>}
    </ApproveAllButton>
  );
};
